'use strict';

var define = require('define-properties');

var callBind = require('es-abstract/helpers/callBind');

var implementation = require('./implementation');

var getPolyfill = require('./polyfill');

var shim = require('./shim');

var bound = callBind(implementation);
define(bound, {
  getPolyfill: getPolyfill,
  implementation: implementation,
  shim: shim
});
module.exports = bound;